module.exports = __webpack_public_path__ + "img/HeimwehScreenshot07.6b053d0a.png";